// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            tooltipContainer: css`
                white-space: normal;
            `,
            /* Store Custom Code - Start */
            tooltipBody: css`
                background-color: ${getColor("common.accent")};
                color: ${getColor("text")};
                box-shadow: ${x => x.theme.shadows[1]};
                border-radius: ${pxToRem(4)};
                min-width: 0;
                padding: ${pxToRem(16)};
            `,
            tooltipArrow: css`
                border-width: ${pxToRem(10)};
                ${(props: any) => `border-${props.direction || "top"}-color`}: ${getColor("common.accent")};
            `,
            /* Store Custom Code - End */
        },
        typographyProps: {
            weight: "normal",
        },
    },
};

export default tooltip;
